export default {
  createTopicFeedbackTemplate: '/topicFeedbackTemplate/createTopicFeedbackTemplate',
  getTopicFeedbackTemplatesOfAnInstitute: '/topicFeedbackTemplate/getTopicFeedbackTemplatesOfAnInstitute',
  getTopicFeedbackTemplateById: '/topicFeedbackTemplate/getTopicFeedbackTemplateById'
}
